
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BaseError": [
      "ValidationError"
    ],
    "BasePortfolioActivity": [
      "PortfolioActivityVirtualKoov"
    ],
    "LearningEvaluationActivity": [
      "AssessmentTestAttempt",
      "ContestAttempt"
    ],
    "LearningWork": [
      "ExplPlayerReport",
      "PlayerWork"
    ],
    "Node": [
      "Assessment",
      "AssessmentTest",
      "AssessmentTestAttempt",
      "AssessmentTestReport",
      "Challenge",
      "Contest",
      "ContestAttempt",
      "ContestReport",
      "Curriculum",
      "ExplPlayerReport",
      "GeneratedImage",
      "Organization",
      "Partner",
      "PartnerRewardPayout",
      "Player",
      "PlayerWork",
      "PortfolioActivityVirtualKoov",
      "PrimarySkill",
      "SecondarySkill",
      "SkillStep",
      "TertiarySkill",
      "VirtualKoovLessonGroup"
    ],
    "PartnerUpdateError": [
      "ValidationError"
    ],
    "PortfolioActivity": [
      "PortfolioActivityVirtualKoov"
    ],
    "RewardItem": [
      "AvatarPartRewardItem",
      "CommentStampRewardItem",
      "FigureRewardItem"
    ],
    "ValidationType": [
      "FormatValidation",
      "LengthValidation",
      "UniqueValidation"
    ]
  }
};
      export default result;
    